var exports = {
  "root": "x24da60e8--eab47f--root",
  "item": "x24da60e8--eab47f--item",
  "tablet": "x24da60e8--eab47f--tablet",
  "phone": "x24da60e8--eab47f--phone",
};

module.exports = exports;
